import { useCallback } from 'react';

import { ApiSectionNamespace } from '@api';
import {
  useHttpClientAwaitable,
  GRAPHQL_HEADER,
  httpMethods,
  IGeneralRequestResponse,
  IGraphQLMutationPrimitive,
  IHttpHookResponseAwaitable,
} from '@services/httpClientService';

import { transformCartBenefits } from '../../../mapper';
import { IVoucherItem, IVoucherUpdateData } from '../model';

import { DELETE_VOUCHER_MUTATION_V2 } from './deleteVoucherMutation';
import { IDeleteVouchersResponse } from './model';

const mappingFunction = (result: IDeleteVouchersResponse): IGeneralRequestResponse<IVoucherUpdateData> => ({
  ...result.deleteVoucher,
  data: {
    ...result.deleteVoucher.data,
    benefits: transformCartBenefits(result.deleteVoucher.data.benefits),
  },
});

export const useDeleteVoucherAwaitable = (): IHttpHookResponseAwaitable<
  IGeneralRequestResponse<IVoucherUpdateData>,
  IVoucherItem
> => {
  const { request: awaitableRequest } = useHttpClientAwaitable<
    IGeneralRequestResponse<IVoucherUpdateData>,
    IGraphQLMutationPrimitive<IVoucherItem>,
    IDeleteVouchersResponse
  >({
    method: httpMethods.DELETE,
    path: ApiSectionNamespace.ECartPageApiKeys.CART_PAGE_VOUCHERS_URL,
    mappingFunction,
    customHeaders: GRAPHQL_HEADER,
  });

  const request = useCallback(
    (data?: IVoucherItem) => {
      const payload = { query: DELETE_VOUCHER_MUTATION_V2 };

      return awaitableRequest({
        data: payload,
        ...(data && { restUrlParams: [{ name: 'voucherCode', value: data.code }] }),
      });
    },
    [awaitableRequest],
  );

  return { request };
};
